import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import OtherOption from './OtherOption';

const ModalInput = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const modalData = useSelector(state => state.cbModalData);
	const {fv, option, checkedValues} = props;

	const onChange = (e) => {
		const { checked, value } = e.target;
		//console.log(`value`, value, 'checked', checked);

		if (checked) {
			const payload = [...checkedValues];
			payload.push(value);
			dispatch({type: 'SET_CBMODAL_DATA', payload: {
				...modalData,
				checkedValues: payload
			}});

		} else {
			const payload = [...checkedValues];
			const index = payload.indexOf(value);
			if (index > -1) {
				payload.splice(index, 1);
			}
			dispatch({type: 'SET_CBMODAL_DATA', payload: {
				...modalData,
				checkedValues: payload
			}});
		}
	};

	return (
		<li>
			<input
				type="checkbox"
				name="option[]"
				id={`option-${option.value}`}
				value={option.value}
				checked={checkedValues.indexOf(option.value) >= 0}
				onChange={onChange}
			/>
			<label htmlFor={`option-${option.value}`}>
	            <div className="d-flex gap-3 opt" data-mode="NOPIC">
	                <div className="x-checkbox"></div>
	                <div className="ans">
	                    {option.value !== 'other' ? (
	                    	<p className="mb-0">{option.label}</p>
	                    ) : (
	                    	<OtherOption
	                    		key={`input-other`}
	                    		lang={props.lang}
	                    		option={option}
	                    		checkedValue={checkedValues.indexOf('other') >= 0 ? 'other' : ''}
	                    		fv={fv}
	                    	/>
	                    )}
	                    <div className="pic w-100"></div>
	                </div>
	            </div>
	        </label>
	   	</li>
	);
}

export default ModalInput;